<template>
    <div class="md-layout" v-if="screenVisible">
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Pesquisar</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <div class="md-layout">
                        <div
                            class="md-layout-item md-size-25 md-small-size-100"
                        >
                            <md-field>
                                <label for="channel"
                                    >Árvore de sortimento</label
                                >
                                <md-input
                                    name="node"
                                    id="node"
                                    value=""
                                    style="cursor: pointer;"
                                    v-model="filterNodeName"
                                    @click="treeModalOpen(true)"
                                    readonly
                                >
                                </md-input>
                                <md-icon>account_tree</md-icon>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-75 md-small-size-100"
                        >
                            <md-field>
                                <label>Produto</label>
                                <vue-simple-suggest
                                    v-model="productModel"
                                    :list="productsList"
                                    :debounce="500"
                                    display-attribute="name"
                                    value-attribute="id"
                                    placeholder="Produto"
                                    @select="productSelected"
                                >
                                </vue-simple-suggest>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-50 md-small-size-100"
                        >
                            <md-field
                                title="Insira o ID dos CDs (separados por vírgula)"
                            >
                                <label
                                    style="top: -0.8rem; font-size: 0.6875rem;"
                                >
                                    CD(s)
                                </label>
                                <multiselect
                                    name="dcs"
                                    v-model="selectedHistoryFilterDcs"
                                    :custom-label="getDcName"
                                    :options="dcsData"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    label="name"
                                    track-by="external_id"
                                    placeholder="Selecione"
                                ></multiselect>
                            </md-field>
                        </div>
                        <div
                            class="md-layout-item md-size-50 md-small-size-100"
                        >
                            <md-field
                                title="Insira o ID das Lojas (separados por vírgula)"
                            >
                                <label
                                    style="top: -0.8rem; font-size: 0.6875rem;"
                                >
                                    Loja(s)
                                </label>
                                <multiselect
                                    name="stores"
                                    v-model="selectedHistoryFilterStores"
                                    :custom-label="getStoreName"
                                    :options="branchesData"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    label="name"
                                    track-by="external_id"
                                    placeholder="Selecione"
                                ></multiselect>
                            </md-field>
                        </div>
                        <div class="md-layout-item md-size-100 text-right mt-1">
                            <md-button
                                class="md-danger md-sm ml-1"
                                @click="clearFilter()"
                            >
                                Limpar
                            </md-button>
                            <md-button
                                class="md-primary md-sm ml-1"
                                @click="applyFilter()"
                            >
                                Pesquisar
                            </md-button>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>

        <!-- Expand Table -->
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Necessidade das Filiais</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <ExpandTable
                        v-bind:headers="branches_needs_headers"
                        v-bind:headersExpands="branches_needs_expands"
                        v-bind:data="branches_needs"
                        v-bind:isPagination="true"
                        @handlerPagination="handlerPaginationBranch"
                        v-bind:isLoading="isBranchNeedsLoading"
                    />
                </md-card-content>
            </md-card>
        </div>

        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-0">
                    <h4 class="title pt-1">Atendimento de necessidades</h4>
                </md-card-header>
                <md-card-content class="pt-2 pb-2">
                    <ExpandTable
                        v-bind:headers="dc_needs_headers"
                        v-bind:headersExpands="dc_needs_expands"
                        v-bind:data="dc_needs"
                        v-bind:isPagination="true"
                        @handlerPagination="handlerPaginationDc"
                        v-bind:isLoading="isDcNeedsLoading"
                    />
                </md-card-content>
            </md-card>
        </div>

        <!-- Modal to select tree node -->
        <modal v-if="treeModal" @close="treeModalOpen(false)" width="500px">
            <template slot="header">
                <h4 class="modal-title">
                    Item da árvore de sortimento
                </h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="treeModalOpen(false)"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <v-draggable-treeview
                    v-model="treeData"
                    :editable="false"
                    :openCallback="readTreeChild"
                    :clickCallback="selectTreeChild"
                ></v-draggable-treeview>
            </template>

            <template slot="footer">
                <div>
                    <p class="card-category">
                        Mostrando itens {{ nodeFrom }} a {{ nodeTo }} de um
                        total de {{ nodeTotal }}.
                    </p>
                </div>
                <pagination
                    class="pagination-no-border pagination-success"
                    v-model="nodePagination.currentPage"
                    :per-page="nodePagination.perPage"
                    :total="nodeTotal"
                >
                </pagination>
            </template>
        </modal>
    </div>
    <div v-else>
        <div v-if="me">
            Você não pode acessar essa página!
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import VueSimpleSuggest from 'vue-simple-suggest'
import { Pagination, VuetifyDraggableTreeview, Modal } from '@/components'
import Node from '@/models/node.model'
import { ProductService } from '@/services/product.service'
import ExpandTable from '@/components/Tables/ExpandTable.vue'

export default {
    async created() {
        await this.getMe()
        await this.readBranches()
        await this.readDcs()
    },
    components: {
        Pagination,
        Modal,
        Multiselect,
        VueSimpleSuggest,
        'v-draggable-treeview': VuetifyDraggableTreeview,
        ExpandTable
    },
    data() {
        return {
            filterNode: new Node(),
            filterNodeName: 'Todos os itens',
            nodePagination: {
                perPage: parseInt(process.env.VUE_APP_DEFAULT_PAGE_SIZE),
                currentPage: 1,
                total: 0
            },
            treeModal: false,

            productModel: '',
            selectedHistoryFilterFields: {
                product: null
            },
            selectedHistoryFilterName: null,
            filterDirty: false,

            selectedHistoryFilterDcs: [],
            selectedHistoryFilterStores: [],

            branches_needs_expands: ['current_stock', 'considered_stock'],
            branches_needs_headers: [
                { text: 'Filial', value: 'branch' },
                { text: 'PV 15D', value: 'pvd15' },
                { text: 'MDV 15D', value: 'mdv15' },
                { text: 'MDV 30D', value: 'mdv30' },
                {
                    text: 'Estoque Atual',
                    value: 'current_stock',
                    sortable: false
                },
                {
                    text: 'Estoque Considerado',
                    value: 'considered_stock',
                    sortable: false
                },
                { text: 'Necessidade', value: 'need' },
                {
                    text: 'Distribuição Planejada',
                    value: 'planned_distribution'
                }
            ],

            branches_needs: {},

            dc_needs_expands: ['current_stock'],
            dc_needs_headers: [
                { text: 'CD', value: 'dc' },
                {
                    text: 'Estoque Atual',
                    value: 'current_stock'
                },
                { text: 'Necessidades', value: 'sum_needs_dcs_met' },
                {
                    text: 'Distribuição Planejada',
                    value: 'planned_distribution'
                },
                {
                    text: 'Estoque após Atendimento',
                    value: 'virtual_stock'
                },
                { text: 'Necessidade Excedente', value: 'surplus_need' }
            ],
            dc_needs: {},

            isBranchNeedsLoading: false,
            isDcNeedsLoading: false
        }
    },
    methods: {
        ...mapActions('auth', { getMe: 'me' }),

        ...mapActions('nodes', {
            readTreeNodes: 'read',
            readTreeAncestors: 'readAncestors'
        }),

        ...mapActions('branches', {
            readDcs: 'readDcs',
            readBranches: 'readBranches'
        }),

        ...mapActions('restocking', {
            readBranchNeeds: 'readBranchNeeds',
            readDcNeeds: 'readDcNeeds'
        }),

        treeModalOpen(state) {
            this.treeModal = state
        },

        readTreeChild(item) {
            return this.readTreeNodes({ item })
        },

        async selectTreeChild(item) {
            this.filterNode = item
            //this.selectedNodeName = 'Carregando árvore...'
            this.treeModal = false
            await this.readTreeAncestors({ id: item.id })

            if (item.id == null) {
                this.filterNodeName = 'Todos os itens'
                this.treeModal = false
            } else {
                this.filterNodeName = ''
                this.treeAncestors.forEach((ancestor, index) => {
                    if (index > 0) this.filterNodeName += ' > '
                    this.filterNodeName += ancestor.name
                })
            }
        },

        async applyFilter() {
            if (!this.selectedHistoryFilterFields.product) {
                this.$notify({
                    message: 'Selecione pelo menos um produto',
                    icon: 'add_alert',
                    horizontalAlign: 'right',
                    verticalAlign: 'bottom',
                    type: 'danger'
                })
            } else {
                try {
                    this.isBranchNeedsLoading = true
                    this.isDcNeedsLoading = true

                    await this.readBranchNeeds({
                        node: this.filterNode.id,
                        stores: this.selectedHistoryFilterStores
                            .map(o => o.external_id)
                            .join(),
                        product: this.selectedHistoryFilterFields.product
                    })

                    await this.readDcNeeds({
                        node: this.filterNode.id,
                        dcs: this.selectedHistoryFilterDcs
                            .map(o => o.external_id)
                            .join(),
                        product: this.selectedHistoryFilterFields.product
                    })

                    this.branches_needs = {
                        ...this.branchNeeds,
                        results: this.branchNeeds.results.map(item => ({
                            branch: `${item.branch.external_id} - ${item.branch.name}`,
                            pvd15: item.pvd15,
                            mdv15: item.mdv15,
                            mdv30: item.mdv30,
                            current_stock: {
                                value: item.current_stock,
                                expand_values: [
                                    {
                                        text: `Pedidos Criados = ${item.solicitation_stock}`
                                    },
                                    {
                                        text: `Pedidos Trânsito = ${item.transit_stock}`
                                    },
                                    {
                                        text: `Estoque Loja = ${item.store_stock}`
                                    }
                                ]
                            },
                            considered_stock: {
                                value: item.considered_stock,
                                expand_values: [
                                    {
                                        text: `Most. + Pilha = ${item.secondary_suggested_stock}`
                                    },
                                    {
                                        text: `Est. Sug. + Most. = ${item.suggested_stock}`
                                    }
                                ]
                            },
                            needs: item.needs,
                            planned_distribution: item.planned_distribution
                        }))
                    }

                    this.dc_needs = {
                        ...this.dcNeeds,
                        results: this.dcNeeds.results.map(item => ({
                            dc: `${item.dc.external_id} - ${item.dc.name}`,
                            current_stock: {
                                value: item.current_stock,
                                expand_values: [
                                    {
                                        text: `Pedidos Criados = ${item.solicitation_stock}`
                                    },
                                    {
                                        text: `Pedidos Trânsito = ${item.transit_stock}`
                                    },
                                    {
                                        text: `Estoque Loja = ${item.store_stock}`
                                    }
                                ]
                            },
                            sum_needs_dcs_met: item.sum_needs_dcs_met,
                            planned_distribution: item.planned_distribution,
                            virtual_stock: item.virtual_stock,
                            surplus_need: item.surplus_need
                        }))
                    }
                } finally {
                    this.isBranchNeedsLoading = false
                    this.isDcNeedsLoading = false
                }
            }
        },

        clearFilter() {
            this.filterNode = new Node()
            this.filterNodeName = 'Todos os itens'
            this.productModel = ''
            this.selectedHistoryFilterFields.product = null
            this.selectedHistoryFilterStores = []
            this.selectedHistoryFilterDcs = []
        },

        async productsList() {
            let products = await ProductService.read({
                q: this.productModel
            })
                .then(res => res.data)
                .then(json => json.results)
            products = products.map(item => {
                item.name = item.external_id + ' - ' + item.name
                return item
            })
            return products
        },

        productSelected(selectedItem) {
            this.productModel = selectedItem.name
            this.selectedHistoryFilterFields['product'] = selectedItem.id
        },

        getDcName: dc => {
            return dc.external_id + ' - ' + dc.name
        },

        getStoreName: branch => {
            if (branch) {
                return branch.external_id + ' - ' + branch.name
            }
        },

        async handlerPaginationBranch(value) {
            await this.readBranchNeeds({
                node: this.filterNode.id,
                stores: this.selectedHistoryFilterStores
                    .map(o => o.external_id)
                    .join(),
                product: this.selectedHistoryFilterFields.product,
                page: value.page,
                limit: value.limit
            })
        },

        async handlerPaginationDc(value) {
            await this.readDcNeeds({
                node: this.filterNode.id,
                dcs: this.selectedHistoryFilterDcs
                    .map(o => o.external_id)
                    .join(),
                product: this.selectedHistoryFilterFields.product,
                page: value.page,
                limit: value.limit
            })
        }
    },
    computed: {
        ...mapState({
            me: state => state['auth'].me,
            treePage: state => state['nodes'].page,
            treeAncestors: state => state['nodes'].ancestors,
            dcsData: state => state['branches'].dcs,
            branchesData: state => state['branches'].branches,
            branchNeeds: state => state['restocking'].branchNeeds,
            dcNeeds: state => state['restocking'].dcNeeds,
            _isBranchNeedsLoading: state =>
                state['restocking'].isBranchNeedsLoading,
            _isDcNeedsLoading: state => state['restocking'].isDcNeedsLoading
        }),

        treeData() {
            return [{ name: 'Todos os itens', id: null }] //this.treePage.results
        },

        nodeFrom() {
            if (this.treePage.results.length > 0)
                return this.treePage.results[0].id
            else return 0
        },

        nodeTo() {
            if (this.treePage.results.length > 0)
                return this.treePage.results[this.treePage.results.length - 1]
                    .id
            else return 0
        },

        nodeTotal() {
            return this.treePage.count
        },

        screenVisible() {
            if (this.me)
                return (
                    this.me.permissions.indexOf('restocking.view_restocking') >
                    -1
                )
            return false
        }
    },
    watch: {}
}
</script>

<style>
.vue-simple-suggest.designed {
    width: 100%;
}

.vue-simple-suggest.designed .input-wrapper input {
    height: 36px;
}

/**** MULTISELECT */

fieldset[disabled] .multiselect {
    pointer-events: none;
}
.multiselect__spinner {
    position: absolute;
    right: 1px;
    top: 1px;
    width: 48px;
    height: 35px;
    background: #fff;
    display: block;
}
.multiselect__spinner:before,
.multiselect__spinner:after {
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    margin: -8px 0 0 -8px;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    border-color: #3c8db9 transparent transparent;
    border-style: solid;
    border-width: 2px;
    box-shadow: 0 0 0 1px transparent;
}
.multiselect__spinner:before {
    animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62);
    animation-iteration-count: infinite;
}
.multiselect__spinner:after {
    animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8);
    animation-iteration-count: infinite;
}
.multiselect__loading-enter-active,
.multiselect__loading-leave-active {
    transition: opacity 0.4s ease-in-out;
    opacity: 1;
}
.multiselect__loading-enter,
.multiselect__loading-leave-active {
    opacity: 0;
}
.multiselect,
.multiselect__input,
.multiselect__single {
    font-family: inherit;
    font-size: 16px;
    touch-action: manipulation;
}
.multiselect {
    box-sizing: content-box;
    display: block;
    position: relative;
    width: 100%;
    min-height: 40px;
    text-align: left;
    color: #35495e;
}
.multiselect * {
    box-sizing: border-box;
}
.multiselect:focus {
    outline: none;
}
.multiselect--disabled {
    background: #ededed;
    pointer-events: none;
    opacity: 0.6;
}
.multiselect--active {
    z-index: 50;
}
.multiselect--active:not(.multiselect--above) .multiselect__current,
.multiselect--active:not(.multiselect--above) .multiselect__input,
.multiselect--active:not(.multiselect--above) .multiselect__tags {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}
.multiselect--active .multiselect__select {
    transform: rotateZ(180deg);
}
.multiselect--above.multiselect--active .multiselect__current,
.multiselect--above.multiselect--active .multiselect__input,
.multiselect--above.multiselect--active .multiselect__tags {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.multiselect__input,
.multiselect__single {
    position: relative;
    display: inline-block;
    min-height: 20px;
    line-height: 20px;
    border: none;
    border-radius: 5px;
    background: #fff;
    padding: 0 0 0 5px;
    width: calc(100%);
    transition: border 0.1s ease;
    box-sizing: border-box;
    margin-bottom: 8px;
    vertical-align: top;
}
.multiselect__input::placeholder {
    color: #35495e;
}
.multiselect__tag ~ .multiselect__input,
.multiselect__tag ~ .multiselect__single {
    width: auto;
}
.multiselect__input:hover,
.multiselect__single:hover {
    border-color: #cfcfcf;
}
.multiselect__input:focus,
.multiselect__single:focus {
    border-color: #a8a8a8;
    outline: none;
}
.multiselect__single {
    padding-left: 5px;
    margin-bottom: 8px;
}
.multiselect__tags-wrap {
    display: inline;
}
.multiselect__tags {
    min-height: 40px;
    display: block;
    padding: 5px 40px 0 0px;
    border-radius: 5px;
    background: #fff;
    font-size: 14px;
}
.multiselect__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: #fff;
    line-height: 1;
    background: #3c8db9;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}
.multiselect__tag-icon {
    cursor: pointer;
    margin-left: 7px;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: 700;
    font-style: initial;
    width: 22px;
    text-align: center;
    line-height: 22px;
    transition: all 0.2s ease;
    border-radius: 5px;
}
.multiselect__tag-icon:after {
    content: '×';
    color: #266d4d;
    font-size: 14px;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
    background: #369a6e;
}
.multiselect__tag-icon:focus:after,
.multiselect__tag-icon:hover:after {
    color: white;
}
.multiselect__current {
    line-height: 16px;
    min-height: 40px;
    box-sizing: border-box;
    display: block;
    overflow: hidden;
    padding: 8px 12px 0;
    padding-right: 30px;
    white-space: nowrap;
    margin: 0;
    text-decoration: none;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    cursor: pointer;
}
.multiselect__select {
    line-height: 16px;
    display: block;
    position: absolute;
    box-sizing: border-box;
    width: 40px;
    height: 38px;
    right: 1px;
    top: 1px;
    padding: 4px 8px;
    margin: 0;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    transition: transform 0.2s ease;
}
.multiselect__select:before {
    position: relative;
    right: 0;
    top: 65%;
    color: #999;
    margin-top: 4px;
    border-style: solid;
    border-width: 5px 5px 0 5px;
    border-color: #999999 transparent transparent transparent;
    content: '';
}
.multiselect__placeholder {
    color: #adadad;
    display: inline-block;
    margin-bottom: 10px;
    padding-top: 2px;
}
.multiselect--active .multiselect__placeholder {
    display: none;
}
.multiselect__content-wrapper {
    position: absolute;
    display: block;
    background: #fff;
    width: 100%;
    max-height: 240px;
    overflow: auto;
    border: 1px solid #e8e8e8;
    border-top: none;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 50000;
    -webkit-overflow-scrolling: touch;
}
.multiselect__content {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
    min-width: 100%;
    vertical-align: top;
}
.multiselect--above .multiselect__content-wrapper {
    bottom: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border-bottom: none;
    border-top: 1px solid #e8e8e8;
}
.multiselect__content::webkit-scrollbar {
    display: none;
}
.multiselect__element {
    display: block;
}
.multiselect__option {
    display: block;
    padding: 12px;
    min-height: 40px;
    line-height: 16px;
    text-decoration: none;
    text-transform: none;
    vertical-align: middle;
    position: relative;
    cursor: pointer;
    white-space: nowrap;
}
.multiselect__option:after {
    top: 0;
    right: 0;
    position: absolute;
    line-height: 40px;
    padding-right: 12px;
    padding-left: 20px;
    font-size: 13px;
}
.multiselect__option--highlight {
    background: #3c8db9;
    outline: none;
    color: white;
}
.multiselect__option--highlight:after {
    content: attr(data-select);
    background: #3c8db9;
    color: white;
}
.multiselect__option--selected {
    background: #f3f3f3;
    color: #35495e;
    font-weight: bold;
}
.multiselect__option--selected:after {
    content: attr(data-selected);
    color: silver;
}
.multiselect__option--selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff;
}
.multiselect__option--selected.multiselect__option--highlight:after {
    background: #ff6a6a;
    content: attr(data-deselect);
    color: #fff;
}
.multiselect--disabled .multiselect__current,
.multiselect--disabled .multiselect__select {
    background: #ededed;
    color: #a6a6a6;
}
.multiselect__option--disabled {
    background: #ededed !important;
    color: #a6a6a6 !important;
    cursor: text;
    pointer-events: none;
}
.multiselect__option--group {
    background: #ededed;
    color: #35495e;
}
.multiselect__option--group.multiselect__option--highlight {
    background: #35495e;
    color: #fff;
}
.multiselect__option--group.multiselect__option--highlight:after {
    background: #35495e;
}
.multiselect__option--disabled.multiselect__option--highlight {
    background: #dedede;
}
.multiselect__option--group-selected.multiselect__option--highlight {
    background: #ff6a6a;
    color: #fff;
}
.multiselect__option--group-selected.multiselect__option--highlight:after {
    background: #ff6a6a;
    content: attr(data-deselect);
    color: #fff;
}
.multiselect-enter-active,
.multiselect-leave-active {
    transition: all 0.15s ease;
}
.multiselect-enter,
.multiselect-leave-active {
    opacity: 0;
}
.multiselect__strong {
    margin-bottom: 8px;
    line-height: 20px;
    display: inline-block;
    vertical-align: top;
}
*[dir='rtl'] .multiselect {
    text-align: right;
}
*[dir='rtl'] .multiselect__select {
    right: auto;
    left: 1px;
}
*[dir='rtl'] .multiselect__tags {
    padding: 8px 8px 0px 40px;
}
*[dir='rtl'] .multiselect__content {
    text-align: right;
}
*[dir='rtl'] .multiselect__option:after {
    right: auto;
    left: 0;
}
*[dir='rtl'] .multiselect__clear {
    right: auto;
    left: 12px;
}
*[dir='rtl'] .multiselect__spinner {
    right: auto;
    left: 1px;
}
@keyframes spinning {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(2turn);
    }
}
</style>
